(function () {
  'use strict';

  var SELECTOR = '[data-al-atlas]';
  var instances = new WeakMap();

  function clamp(value, min, max) { return Math.max(min, Math.min(max, value)); }
  function easeInOutCubic(t) { return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }

  function createAtlas(root) {
    if (!root || instances.has(root)) return;
    var controller = new AbortController();
    var signal = controller.signal;
    var state = {
      country: 'yemen',
      destroyed: false,
      globe: null,
      moving: false,
      media: window.matchMedia('(max-width: 767px)'),
      reduced: window.matchMedia('(prefers-reduced-motion: reduce)').matches,
      panelTimer: 0,
      scrollFrame: 0,
      scrollTimer: 0,
      detailOpen: false,
      returnTarget: null
    };
    instances.set(root, { destroy: destroy });

    var globeElement = root.querySelector('[data-atlas-globe]');
    var desktopHost = root.querySelector('[data-globe-host="desktop"]');
    var mobileHost = root.querySelector('[data-globe-host="mobile"]');
    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-country-button]'));
    var markers = Array.prototype.slice.call(root.querySelectorAll('[data-globe-marker]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-country-panel]'));
    var storyCount = root.querySelector('[data-story-count]');

    function placeGlobe() {
      var host = state.media.matches ? mobileHost : desktopHost;
      if (host && globeElement.parentNode !== host) host.appendChild(globeElement);
      if (state.globe) state.globe.resize();
    }

    function selectCountry(id, options) {
      options = options || {};
      if (!id) return;
      if (options.scroll) {
        state.detailOpen = true;
        state.returnTarget = options.trigger || null;
      }
      if (id === state.country && !options.force) {
        if (state.globe && options.fly !== false) state.globe.flyTo(id);
        if (options.scroll) scrollToStory();
        return;
      }
      var next = panels.find(function (panel) { return panel.getAttribute('data-country-panel') === id; });
      var current = panels.find(function (panel) { return !panel.hidden; });
      if (!next) return;
      state.country = id;
      buttons.forEach(function (button) {
        var active = button.getAttribute('data-country-button') === id;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      markers.forEach(function (button) { button.classList.toggle('is-active', button.getAttribute('data-globe-marker') === id); });
      var order = { yemen: '01 / 03', gaza: '02 / 03', sudan: '03 / 03' };
      if (storyCount) storyCount.textContent = order[id] || '';
      window.clearTimeout(state.panelTimer);
      panels.forEach(function (panel) {
        var active = panel === next;
        panel.hidden = !active;
        panel.setAttribute('aria-hidden', active ? 'false' : 'true');
        panel.classList.remove('is-entering', 'is-leaving');
        panel.classList.toggle('is-active', active);
      });
      if (current !== next && !state.reduced) next.classList.add('is-entering');
      if (state.globe && options.fly !== false) state.globe.flyTo(id);
      if (options.scroll) scrollToStory();
    }

    function scrollToStory() {
      var story = root.querySelector('.al-atlas-story');
      if (!story) return;
      var target = story.querySelector('.al-atlas-story__rail') || story;
      window.clearTimeout(state.scrollTimer);
      window.cancelAnimationFrame(state.scrollFrame);
      state.scrollTimer = window.setTimeout(function () {
        state.scrollFrame = window.requestAnimationFrame(function () {
          state.scrollFrame = 0;
          var targetTop = 0;
          var node = target;
          while (node) {
            targetTop += node.offsetTop || 0;
            node = node.offsetParent;
          }
          var header = document.querySelector('.al-header');
          var headerStyle = header ? window.getComputedStyle(header) : null;
          var headerOffset = header && (headerStyle.position === 'fixed' || headerStyle.position === 'sticky')
            ? header.getBoundingClientRect().height
            : 0;
          var top = Math.max(0, targetTop - headerOffset - 16);
          var active = panels.find(function (panel) { return !panel.hidden; });
          var heading = active && active.querySelector('h2');
          if (heading) {
            heading.setAttribute('tabindex', '-1');
            heading.focus({ preventScroll: true });
          }
          if (Math.abs(window.scrollY - top) < 2) return;
          window.scrollTo({ top: top, behavior: state.reduced ? 'auto' : 'smooth' });
        });
      }, state.reduced ? 0 : 260);
    }

    function returnToGlobe() {
      state.detailOpen = false;
      window.clearTimeout(state.scrollTimer);
      window.cancelAnimationFrame(state.scrollFrame);
      state.scrollFrame = 0;
      var target = state.returnTarget;
      if (!target || !target.getClientRects().length || target.disabled) {
        target = buttons.find(function (button) {
          return button.getAttribute('data-country-button') === state.country && button.getClientRects().length;
        });
      }
      if (target) target.focus({ preventScroll: true });
      var opening = state.media.matches ? mobileHost.parentElement : desktopHost.parentElement;
      var header = document.querySelector('.al-header');
      var headerStyle = header && window.getComputedStyle(header);
      var offset = headerStyle && (headerStyle.position === 'fixed' || headerStyle.position === 'sticky') ? header.getBoundingClientRect().height : 0;
      window.scrollTo({ top: Math.max(0, opening.getBoundingClientRect().top + window.scrollY - offset), behavior: state.reduced ? 'auto' : 'smooth' });
    }

    root.querySelectorAll('[data-back-to-globe]').forEach(function (button) {
      button.addEventListener('click', returnToGlobe, { signal: signal });
    });
    root.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && state.detailOpen && !event.defaultPrevented) {
        event.preventDefault();
        returnToGlobe();
      }
    }, { signal: signal });
    markers.forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.stopPropagation();
        selectCountry(button.getAttribute('data-globe-marker'), { fly: true, scroll: true, trigger: button });
      }, { signal: signal });
    });

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        selectCountry(button.getAttribute('data-country-button'), { fly: true, scroll: true, trigger: button });
      }, { signal: signal });
    });

    state.media.addEventListener('change', placeGlobe, { signal: signal });
    placeGlobe();
    root.classList.add('is-enhanced');
    animateLayout();
    initGlobe();

    function animateLayout() {
      var elements = root.querySelectorAll('[data-atlas-reveal]');
      if (state.reduced || !window.gsap || !window.ScrollTrigger) {
        elements.forEach(function (element) { element.style.opacity = '1'; element.style.transform = 'none'; });
        return;
      }
      root.classList.add('is-animating');
      window.gsap.registerPlugin(window.ScrollTrigger);
      elements.forEach(function (element) {
        window.gsap.fromTo(element, { autoAlpha: 0, y: 42 }, {
          autoAlpha: 1, y: 0, duration: .9, ease: 'power3.out',
          scrollTrigger: { trigger: element, start: 'top 88%', once: true }
        });
      });
    }

    async function initGlobe() {
      try {
        var THREE = window.THREE;
        if (!THREE) {
          await new Promise(function (resolve, reject) {
            var started = performance.now();
            function waitForThree() {
              if (window.THREE) return resolve();
              if (performance.now() - started > 8000) return reject(new Error('Three.js module did not expose window.THREE' + (window.__alThreeError ? ': ' + window.__alThreeError : '')));
              window.setTimeout(waitForThree, 40);
            }
            waitForThree();
          });
          THREE = window.THREE;
        }
        if (state.destroyed) return;
        var response = await fetch(root.getAttribute('data-geography'), { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Geography request failed: ' + response.status);
        var geography = await response.json();
        if (state.destroyed) return;
        state.globe = createGlobe(THREE, geography, globeElement, function (id) { selectCountry(id, { fly: true, scroll: true }); }, state);
        state.globe.flyTo(state.country, true);
      } catch (error) {
        globeElement.classList.add('is-fallback');
        globeElement.setAttribute('data-globe-error', error && (error.stack || error.message) ? (error.stack || error.message).slice(0, 900) : String(error));
        if (window.console && console.warn) console.warn('[Al-Ameer Initiatives] Static globe fallback active.', error);
      }
    }

    function destroy() {
      state.destroyed = true;
      controller.abort();
      window.clearTimeout(state.panelTimer);
      window.clearTimeout(state.scrollTimer);
      window.cancelAnimationFrame(state.scrollFrame);
      if (state.globe) state.globe.destroy();
      if (window.ScrollTrigger) window.ScrollTrigger.getAll().forEach(function (trigger) {
        if (root.contains(trigger.trigger)) trigger.kill();
      });
      instances.delete(root);
    }
  }

  function createGlobe(THREE, geography, holder, onSelect, atlasState) {
    var canvas = holder.querySelector('[data-globe-canvas]');
    var labelElements = Array.prototype.slice.call(holder.querySelectorAll('[data-globe-marker]'));
    var motionButton = holder.querySelector('[data-globe-motion]');
    var motionEnabled = !atlasState.reduced;
    var motionElapsed = 0;
    var lastFrameTime = 0;
    var countryData = window.AlAmeerInitiativesData.countries;
    var isMobile = atlasState.media.matches;
    var scene = new THREE.Scene();
    var camera = new THREE.PerspectiveCamera(32, 1, .1, 100);
    camera.position.set(0, 0, 7.2);
    camera.updateMatrixWorld();
    var renderer = new THREE.WebGLRenderer({ canvas: canvas, alpha: true, antialias: true, powerPreference: 'high-performance', failIfMajorPerformanceCaveat: true });
    renderer.setClearColor(0x000000, 0);
    renderer.outputColorSpace = THREE.SRGBColorSpace;
    var lowPower = navigator.connection && navigator.connection.saveData || navigator.deviceMemory && navigator.deviceMemory <= 4;
    var maxDpr = isMobile ? 1.25 : 1.75;
    if (lowPower) maxDpr = 1;
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, maxDpr));

    var world = new THREE.Group();
    world.rotation.order = 'YXZ';
    scene.add(world);
    scene.add(new THREE.AmbientLight(0xbfa579, 1.2));
    var key = new THREE.DirectionalLight(0xffd99a, 3.3); key.position.set(-3, 4, 5); scene.add(key);
    var rim = new THREE.DirectionalLight(0x8b5c27, 2.2); rim.position.set(4, -1, -2); scene.add(rim);

    var sphere = new THREE.Mesh(
      new THREE.SphereGeometry(1.72, isMobile ? 64 : (lowPower ? 72 : 112), isMobile ? 40 : (lowPower ? 48 : 72)),
      new THREE.MeshStandardMaterial({ color: 0x100d08, roughness: .73, metalness: .38, emissive: 0x080603, emissiveIntensity: .55 })
    );
    world.add(sphere);

    var atmosphere = new THREE.Mesh(
      new THREE.SphereGeometry(1.79, isMobile ? 48 : 64, isMobile ? 32 : 48),
      new THREE.ShaderMaterial({
        transparent: true, blending: THREE.AdditiveBlending, side: THREE.BackSide, depthWrite: false,
        uniforms: { glowColor: { value: new THREE.Color(0xc59147) } },
        vertexShader: 'varying vec3 vNormal; varying vec3 vWorld; void main(){vNormal=normalize(normalMatrix*normal);vec4 p=modelMatrix*vec4(position,1.0);vWorld=p.xyz;gl_Position=projectionMatrix*viewMatrix*p;}',
        fragmentShader: 'uniform vec3 glowColor;varying vec3 vNormal;varying vec3 vWorld;void main(){vec3 viewDir=normalize(cameraPosition-vWorld);float intensity=pow(0.68-max(dot(vNormal,viewDir),0.0),3.0);gl_FragColor=vec4(glowColor,intensity*.68);}'
      })
    );
    scene.add(atmosphere);

    function llToVector(lat, lng, radius) {
      var phi = (90 - lat) * Math.PI / 180;
      var theta = (lng + 180) * Math.PI / 180;
      return new THREE.Vector3(-radius * Math.sin(phi) * Math.cos(theta), radius * Math.cos(phi), radius * Math.sin(phi) * Math.sin(theta));
    }

    function makeLineGeometry(lines, radius) {
      var vertices = [];
      lines.forEach(function (line) {
        for (var index = 0; index < line.length - 2; index += 2) {
          var first = llToVector(line[index + 1], line[index], radius);
          var next = llToVector(line[index + 3], line[index + 2], radius);
          vertices.push(first.x, first.y, first.z, next.x, next.y, next.z);
        }
      });
      var geometry = new THREE.BufferGeometry();
      geometry.setAttribute('position', new THREE.Float32BufferAttribute(vertices, 3));
      return geometry;
    }
    var coastGeometry = makeLineGeometry(geography.coast || [], 1.727);
    var borderGeometry = makeLineGeometry(geography.borders || [], 1.73);
    var coastMaterial = new THREE.LineBasicMaterial({ color: 0xd5ad65, transparent: true, opacity: .58, depthWrite: false });
    var borderMaterial = new THREE.LineBasicMaterial({ color: 0x8d6b3b, transparent: true, opacity: .22, depthWrite: false });
    world.add(new THREE.LineSegments(coastGeometry, coastMaterial));
    world.add(new THREE.LineSegments(borderGeometry, borderMaterial));

    var markerGroup = new THREE.Group(); world.add(markerGroup);
    var markerMeshes = [];
    var markerPositions = {};
    countryData.forEach(function (country) {
      var position = llToVector(country.lat, country.lng, 1.76);
      markerPositions[country.id] = position.clone();
      var group = new THREE.Group(); group.position.copy(position);
      group.quaternion.setFromUnitVectors(new THREE.Vector3(0, 0, 1), position.clone().normalize());
      var dot = new THREE.Mesh(new THREE.SphereGeometry(.037, 18, 14), new THREE.MeshBasicMaterial({ color: 0xffd284 }));
      var ring = new THREE.Mesh(new THREE.RingGeometry(.06, .086, 32), new THREE.MeshBasicMaterial({ color: 0xd3a152, transparent: true, opacity: .72, side: THREE.DoubleSide, depthWrite: false }));
      ring.position.z = -.004;
      var hit = new THREE.Mesh(new THREE.SphereGeometry(.12, 12, 8), new THREE.MeshBasicMaterial({ transparent: true, opacity: 0, depthWrite: false }));
      hit.userData.countryId = country.id;
      group.add(dot, ring, hit); markerGroup.add(group); markerMeshes.push(hit);
    });

    var arcs = [];
    var house = window.AlAmeerInitiativesData.house;
    var origin = llToVector(house.lat, house.lng, 1.74);
    countryData.forEach(function (country, idx) {
      var end = llToVector(country.lat, country.lng, 1.74);
      var mid = origin.clone().add(end).normalize().multiplyScalar(2.02 + idx * .025);
      var curve = new THREE.QuadraticBezierCurve3(origin, mid, end);
      var geometry = new THREE.BufferGeometry().setFromPoints(curve.getPoints(isMobile ? 48 : 96));
      var line = new THREE.Line(geometry, new THREE.LineBasicMaterial({ color: 0xb98745, transparent: true, opacity: .42, depthWrite: false }));
      world.add(line);
      var pulse = new THREE.Mesh(new THREE.SphereGeometry(.026, 12, 10), new THREE.MeshBasicMaterial({ color: 0xffdf9f }));
      var halo = new THREE.Mesh(new THREE.SphereGeometry(.06, 12, 10), new THREE.MeshBasicMaterial({ color: 0xffc76c, transparent: true, opacity: .16, depthWrite: false }));
      pulse.add(halo);
      var trailGeometry = new THREE.BufferGeometry();
      trailGeometry.setAttribute('position', new THREE.Float32BufferAttribute(new Float32Array(36), 3));
      var trail = new THREE.Line(trailGeometry, new THREE.LineBasicMaterial({ color: 0xffd184, transparent: true, opacity: .8, depthWrite: false }));
      trail.frustumCulled = false;
      world.add(pulse, trail); arcs.push({ curve: curve, pulse: pulse, trail: trail, offset: idx / 3 });
    });

    var observerVisible = true;
    var pageVisible = !document.hidden;
    var dragging = false;
    var didDrag = false;
    var touchAxis = null;
    var downX = 0, downY = 0;
    var pointerId = null;
    var lastX = 0, lastY = 0, velocityX = 0, velocityY = 0;
    var interactionUntil = 0;
    var animation = null;
    var destroyed = false;
    var raf = 0;
    var resizeObserver = new ResizeObserver(resize);
    resizeObserver.observe(holder);
    var intersectionObserver = new IntersectionObserver(function (entries) {
      observerVisible = entries[0].isIntersecting;
      if (observerVisible) scheduleRender(); else stopRender();
    }, { rootMargin: '250px' });
    intersectionObserver.observe(holder);
    document.addEventListener('visibilitychange', onVisibility);
    holder.addEventListener('pointerdown', onPointerDown);
    holder.addEventListener('pointermove', onPointerMove);
    holder.addEventListener('pointerup', onPointerUp);
    holder.addEventListener('pointercancel', onPointerUp);
    holder.addEventListener('click', onCanvasClick);
    holder.addEventListener('webglcontextlost', onContextLost, false);
    if (motionButton) motionButton.addEventListener('click', toggleMotion);
    resize();
    holder.classList.add('is-ready');
    updateMotionControl();
    renderFrame(performance.now());
    scheduleRender();

    function updateMotionControl() {
      if (!motionButton) return;
      motionButton.hidden = false;
      motionButton.textContent = motionButton.getAttribute(motionEnabled ? 'data-pause-label' : 'data-play-label');
      motionButton.setAttribute('aria-pressed', motionEnabled ? 'true' : 'false');
    }
    function toggleMotion(event) {
      event.stopPropagation();
      motionEnabled = !motionEnabled;
      lastFrameTime = 0;
      velocityX = velocityY = 0;
      animation = null;
      updateMotionControl();
      if (motionEnabled) scheduleRender(); else { stopRender(); renderFrame(performance.now()); }
    }
    function onVisibility() {
      pageVisible = !document.hidden;
      if (pageVisible) scheduleRender(); else stopRender();
    }
    function onContextLost(event) { event.preventDefault(); if (motionButton) motionButton.hidden = true; stopRender(); holder.classList.remove('is-ready'); holder.classList.add('is-fallback'); }
    function resize() {
      var rect = holder.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      camera.aspect = rect.width / rect.height;
      camera.updateProjectionMatrix();
      renderer.setSize(rect.width, rect.height, false);
      if (!motionEnabled) renderFrame(performance.now());
    }
    function onPointerDown(event) {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      if (event.target.closest('[data-globe-marker], [data-globe-motion]')) return;
      dragging = true; didDrag = false; pointerId = event.pointerId; downX = lastX = event.clientX; downY = lastY = event.clientY; velocityX = velocityY = 0;
      touchAxis = event.pointerType === 'touch' ? 'pending' : 'horizontal';
      if (event.pointerType !== 'touch') holder.setPointerCapture(pointerId);
      holder.classList.add('is-dragging'); animation = null; interactionUntil = performance.now() + 5000;
    }
    function onPointerMove(event) {
      if (!dragging || event.pointerId !== pointerId) return;
      var dx = event.clientX - lastX, dy = event.clientY - lastY;
      if (event.pointerType === 'touch' && touchAxis === 'pending') {
        var totalX = event.clientX - downX, totalY = event.clientY - downY;
        if (Math.max(Math.abs(totalX), Math.abs(totalY)) < 8) return;
        didDrag = true;
        touchAxis = Math.abs(totalY) > Math.abs(totalX) * 1.08 ? 'vertical' : 'horizontal';
        if (touchAxis === 'vertical') { dragging = false; pointerId = null; holder.classList.remove('is-dragging'); return; }
        holder.setPointerCapture(event.pointerId);
        lastX = event.clientX; lastY = event.clientY;
        return;
      }
      if (touchAxis === 'vertical') return;
      if (Math.abs(event.clientX - downX) + Math.abs(event.clientY - downY) > 8) didDrag = true;
      dx = clamp(dx, -18, 18); dy = clamp(dy, -18, 18);
      event.preventDefault(); rotate(dx, isMobile ? 0 : dy); velocityX = dx; velocityY = isMobile ? 0 : dy; lastX = event.clientX; lastY = event.clientY; interactionUntil = performance.now() + 5000;
      if (!motionEnabled) renderFrame(performance.now()); else scheduleRender();
    }
    function onPointerUp(event) {
      if (event.pointerId !== pointerId) return;
      if (holder.hasPointerCapture(event.pointerId)) holder.releasePointerCapture(event.pointerId);
      if (!motionEnabled) velocityX = velocityY = 0;
      dragging = false; touchAxis = null; holder.classList.remove('is-dragging'); pointerId = null; interactionUntil = performance.now() + 5000;
    }
    function rotate(dx, dy) {
      var yaw = new THREE.Quaternion().setFromAxisAngle(new THREE.Vector3(0, 1, 0), dx * .0045);
      var pitch = new THREE.Quaternion().setFromAxisAngle(new THREE.Vector3(1, 0, 0), dy * .0036);
      world.quaternion.premultiply(yaw).premultiply(pitch).normalize();
    }
    function onCanvasClick(event) {
      if (event.target.closest('[data-globe-marker], [data-globe-motion]')) return;
      if (didDrag) { didDrag = false; return; }
      if (Math.abs(velocityX) + Math.abs(velocityY) > 5) return;
      var rect = canvas.getBoundingClientRect();
      var pointer = new THREE.Vector2((event.clientX - rect.left) / rect.width * 2 - 1, -((event.clientY - rect.top) / rect.height) * 2 + 1);
      world.updateMatrixWorld(true);
      var raycaster = new THREE.Raycaster(); raycaster.setFromCamera(pointer, camera);
      var intersections = raycaster.intersectObjects([sphere].concat(markerMeshes), false);
      if (intersections.length && intersections[0].object.userData.countryId) onSelect(intersections[0].object.userData.countryId);
    }
    function flyTo(id, immediate) {
      var position = markerPositions[id]; if (!position) return;
      var target = new THREE.Quaternion().setFromUnitVectors(position.clone().normalize(), new THREE.Vector3(0, 0, 1));
      if (immediate || !motionEnabled) { world.quaternion.copy(target); animation = null; velocityX = velocityY = 0; renderFrame(performance.now()); return; }
      animation = { from: world.quaternion.clone(), to: target, started: performance.now(), duration: 1120 };
      interactionUntil = performance.now() + 5000;
      scheduleRender();
    }
    function updateLabels() {
      var rect = holder.getBoundingClientRect();
      countryData.forEach(function (country, index) {
        var local = markerPositions[country.id];
        var worldPosition = local.clone().applyQuaternion(world.quaternion);
        var front = worldPosition.clone().normalize().dot(new THREE.Vector3(0,0,1)) > .1;
        var projected = worldPosition.clone().project(camera);
        var label = labelElements.find(function (element) { return element.getAttribute('data-globe-marker') === country.id; });
        if (!label) return;
        label.style.left = ((projected.x + 1) * .5 * rect.width) + 'px';
        label.style.top = ((1 - projected.y) * .5 * rect.height) + 'px';
        var visible = front && projected.z < 1;
        label.classList.toggle('is-visible', visible);
        label.disabled = !visible;
      });
    }
    function renderFrame(now) {
        if (animation) {
          var progress = clamp((now - animation.started) / animation.duration, 0, 1);
          world.quaternion.copy(animation.from).slerp(animation.to, easeInOutCubic(progress));
          if (progress >= 1) animation = null;
        } else if (!dragging && motionEnabled) {
          if (Math.abs(velocityX) + Math.abs(velocityY) > .08) {
            rotate(velocityX, velocityY); velocityX *= .92; velocityY *= .92;
          } else if (now > interactionUntil && !holder.contains(document.activeElement)) rotate(.028, 0);
        }
        if (motionEnabled && lastFrameTime) motionElapsed += Math.min(now - lastFrameTime, 100) / 1000;
        lastFrameTime = now;
        arcs.forEach(function (arc) {
          var travel = (motionElapsed * .12 + arc.offset) % 1;
          arc.pulse.position.copy(arc.curve.getPoint(travel));
          var positions = arc.trail.geometry.attributes.position;
          for (var index = 0; index < positions.count; index++) {
            var point = arc.curve.getPoint(Math.max(0, travel - .1 + .1 * index / (positions.count - 1)));
            positions.setXYZ(index, point.x, point.y, point.z);
          }
          positions.needsUpdate = true;
        });
        updateLabels(); renderer.render(scene, camera);
    }
    function render(now) {
      raf = 0;
      if (destroyed) return;
      if (observerVisible && pageVisible) renderFrame(now);
      scheduleRender();
    }
    function scheduleRender() {
      if (destroyed || raf || !observerVisible || !pageVisible || !motionEnabled || holder.classList.contains('is-fallback')) return;
      raf = requestAnimationFrame(render);
    }
    function stopRender() {
      lastFrameTime = 0;
      if (!raf) return;
      cancelAnimationFrame(raf);
      raf = 0;
    }
    function destroy() {
      destroyed = true; stopRender(); resizeObserver.disconnect(); intersectionObserver.disconnect();
      document.removeEventListener('visibilitychange', onVisibility);
      if (motionButton) motionButton.removeEventListener('click', toggleMotion);
      holder.removeEventListener('pointerdown', onPointerDown); holder.removeEventListener('pointermove', onPointerMove); holder.removeEventListener('pointerup', onPointerUp); holder.removeEventListener('pointercancel', onPointerUp); holder.removeEventListener('click', onCanvasClick); holder.removeEventListener('webglcontextlost', onContextLost);
      scene.traverse(function (object) { if (object.geometry) object.geometry.dispose(); if (object.material) { (Array.isArray(object.material) ? object.material : [object.material]).forEach(function (material) { material.dispose(); }); } });
      renderer.dispose();
    }
    return { resize: resize, flyTo: flyTo, destroy: destroy };
  }

  function boot(scope) { (scope || document).querySelectorAll(SELECTOR).forEach(createAtlas); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); }, { once: true }); else boot(document);
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { var root = event.target.querySelector(SELECTOR); if (root && instances.has(root)) instances.get(root).destroy(); });
})();
